import enMain from '../../locales/en/main.json';
import ruMain from '../../locales/ru/main.json';
import srMain from '../../locales/sr/main.json';

export type ModalLabels = {
  title: string;
  certType: string;
  amount: string;
  name: string;
  email: string;
  phone: string;
  errName: string;
  errPhone: string;
  errEmail: string;
  errConsent: string;
  consent: string;
  submit: string;
  sending: string;
  success: string;
  error: string;
  amountModalOptions: { value: string; label: string }[];
  currency: string;
};

function giftCertsByPath() {
  const path = window.location.pathname;
  if (path.includes('/sr/')) return srMain.giftCerts;
  if (path.includes('/ru/')) return ruMain.giftCerts;
  return enMain.giftCerts;
}

export function getModalLabels(): ModalLabels {
  const gc = giftCertsByPath();
  return {
    title: gc.modalTitle,
    certType: gc.modalCertType,
    amount: gc.modalAmount,
    name: gc.modalName,
    email: gc.modalEmail,
    phone: gc.modalPhone,
    errName: gc.modalErrName,
    errPhone: gc.modalErrPhone,
    errEmail: gc.modalErrEmail,
    errConsent: gc.modalErrConsent,
    consent: gc.modalConsent,
    submit: gc.modalSubmit,
    sending: gc.modalSending,
    success: gc.modalSuccess,
    error: gc.modalError,
    amountModalOptions: gc.amountModalOptions,
    currency: gc.currency,
  };
}
